import type { I18nOptions } from 'vue-i18n';

const formats = {
  currency: { currency: 'EUR', currencyDisplay: 'symbol', style: 'currency' },
  compactCurrency: {
    currency: 'EUR',
    currencyDisplay: 'symbol',
    style: 'currency',
    notation: 'compact',
  },
  compact: { notation: 'compact', compactDisplay: 'short' },
  percent: { style: 'percent', useGrouping: false },
  seconds: { style: 'unit', unit: 'second', unitDisplay: 'narrow' },
  minutes: { style: 'unit', unit: 'minute', unitDisplay: 'narrow' },
  hours: { style: 'unit', unit: 'hour', unitDisplay: 'narrow' },
  days: { style: 'unit', unit: 'day', unitDisplay: 'narrow' },
} as const;

export const numberFormats: I18nOptions['numberFormats'] = {
  'de-DE': formats,
  'en-US': formats,
};
